import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum TaskStatusEnum {
  未完成 = 0,
  可领取 = 1,
  已全部完成 = 2,
}
export enum PrayEnum {
  普通祈福 = 0,
  充值活动祈福 = 1,
}
interface PetInfo {
  fodder: number
  pray_count: number
  unclaimed_pray_count: number
  level: number
  exp: number
  upgrade_exp: number
  need_exp: number
  available: number
  card_count: number
  advanced_card_count: number
  member: MemberInfo
}
interface MemberInfo {
  id: number
  name: string
  zyid: string
  avatar_urls: {
    origin: {
      urls: Array<string>
    }
  }
}
export interface HistoryInfo {
  id: number
  name: string
  date: string
  score: number
}
export interface PrayInfo {
  mid?: number
  msg: string
  type: PrayEnum
  member: MemberInfo
}
export interface TaskInfo {
  task_id: number
  name: string
  status: TaskStatusEnum
  cur_count: number
  max_count: number
  img: string
}
export interface GoodsInfo {
  goods_id: number
  name: string
  img: string
  pray_count: number
}
interface PopupInfo {
  show: boolean
  fodder: number
}
export interface FriendItem {
  mid: number
  member: MemberInfo
}

// 主页
export const act_feeding_homepage = createAsyncThunk(
  'act_feeding_homepage',
  async (arg: {target_mid?: number}, store: any) => {
    const {deviceinfo} = store.getState().env
    const {h_m} = deviceinfo
    const resp = await http.post('/live/activity/act_feeding_homepage', {
      ...store.getState().env.deviceinfo,
      target_mid: arg.target_mid || h_m,
    })
    return resp.data.data
  }
)
// 显示完新手教程
export const act_feeding_show_popup = createAsyncThunk(
  'act_feeding_show_popup',
  async (arg, store: any) => {
    const resp = await http.post('/live/activity/act_feeding_show_popup', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 好友列表
export const act_feeding_friend_list = createAsyncThunk(
  'act_feeding_friend_list',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const {h_m} = deviceinfo
    const resp = await http.post('/live/activity/act_feeding_friend_list', {
      ...store.getState().env.deviceinfo,
      target_mid: h_m,
    })
    return resp.data.data
  }
)
// 投喂
export const act_feeding_feed = createAsyncThunk(
  'act_feeding_feed',
  async (arg: {target_mid?: number}, store: any) => {
    const {deviceinfo} = store.getState().env
    const {h_m} = deviceinfo
    const resp = await http.post(
      '/live/activity/act_feeding_feed',
      {
        ...store.getState().env.deviceinfo,
        target_mid: arg.target_mid || h_m,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 完成任务
export const act_feeding_finish_task = createAsyncThunk(
  'act_feeding_finish_task',
  async (arg: {task_id: number}, store: any) => {
    const resp = await http.post('/live/activity/act_feeding_finish_task', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// 祈福
export const act_feeding_pray = createAsyncThunk(
  'act_feeding_pray',
  async (arg: {type: PrayEnum; msg: string}, store: any) => {
    const resp = await http.post(
      '/live/activity/act_feeding_pray',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 兑换商品
export const act_feeding_exchange = createAsyncThunk(
  'act_feeding_exchange',
  async (arg: {goods_id: number; count: number}, store: any) => {
    const resp = await http.post('/live/activity/act_feeding_exchange', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// 领取祈福值
export const act_feeding_receive_pray = createAsyncThunk(
  'act_feeding_receive_pray',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/activity/act_feeding_receive_pray',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface InitialStateType {
  my_pet?: PetInfo // 我的宠物信息
  target_pet?: PetInfo // 对方的宠物信息
  list?: Array<PrayInfo> // 祈福墙
  task_list?: Array<TaskInfo> // 任务列表
  goods_list?: Array<GoodsInfo> // 商品列表
  popup_info?: PopupInfo // 弹窗信息
  friends_list?: Array<FriendItem> // 好友列表
  guide: {
    show: boolean
    step: number
  }
  amis: {
    showLoop: boolean
    showInteract: boolean
    showUpdate: boolean
  }
  isMy: boolean
  activeTab: number
}

const initialState: InitialStateType = {
  friends_list: [],
  guide: {
    show: false,
    step: 0,
  },
  amis: {
    showLoop: true,
    showInteract: false,
    showUpdate: false,
  },
  isMy: true,
  activeTab: 0,
}
export const RamadanActiveSlice = createSlice({
  name: 'RamadanActive',
  initialState,
  reducers: {
    addPrayList: (state, action) => {
      Object.assign(state, {
        list: action.payload,
      })
    },
    changeTask: (state, action) => {
      const idx = action.payload
      const {task_list} = state
      task_list[idx].status = TaskStatusEnum.已全部完成
      Object.assign(state, {
        task_list,
      })
    },
    changeGuide: (state, action) => {
      const {guide} = state
      Object.assign(state, {
        guide: {
          ...guide,
          ...action.payload,
        },
      })
    },
    changeAmis: (state, action) => {
      const {amis} = state
      Object.assign(state, {
        amis: {
          ...amis,
          ...action.payload,
        },
      })
    },
    changePopupInfo: (state, action) => {
      const {popup_info} = state
      Object.assign(state, {
        popup_info: {
          ...popup_info,
          ...action.payload,
        },
      })
    },
    changeActiveTab: (state, action) => {
      Object.assign(state, {
        activeTab: action.payload,
      })
    },
    switchToMyKittyFarm: (state, action) => {
      Object.assign(state, {
        isMy: true,
      })
    },
    switchToFriendKittyFarm: (state, action) => {
      Object.assign(state, {
        isMy: false,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(act_feeding_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(act_feeding_pray.fulfilled, (state, action) => {
      const {my_pet} = action.payload
      Object.assign(state, {my_pet})
    })
    builder.addCase(act_feeding_receive_pray.fulfilled, (state, action) => {
      const {my_pet, target_pet} = action.payload
      Object.assign(state, {my_pet, target_pet})
    })
    builder.addCase(act_feeding_feed.fulfilled, (state, action) => {
      const {my_pet, target_pet} = action.payload
      Object.assign(state, {my_pet, target_pet})
    })
    builder.addCase(act_feeding_finish_task.fulfilled, (state, action) => {
      const {my_pet} = action.payload
      Object.assign(state, {my_pet})
    })
    builder.addCase(act_feeding_exchange.fulfilled, (state, action) => {
      const {my_pet} = action.payload
      Object.assign(state, {my_pet})
    })
    builder.addCase(act_feeding_friend_list.fulfilled, (state, action) => {
      const {list} = action.payload
      Object.assign(state, {friends_list: list})
    })
  },
})
export default RamadanActiveSlice.reducer
export const RamadanActiveActions = RamadanActiveSlice.actions
